module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"type":{"NGO":"ONG","DISCOUNT":"Descuento","SHAMPOO":"Shampoo","PLASTIC_BOTTLE":"Botella de Plástico"}},"en":{"type":{"NGO":"NGO","DISCOUNT":"Discount","SHAMPOO":"Shampoo","PLASTIC_BOTTLE":"Plastic Bottle"}}}')
  delete Component.options._Ctor
}
